import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { Slide } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useDeleteSlide, useSlide, useUpdateSlide } from '../../hooks/slides'
import SlideForm from '../../components/SlideForm'

export default function SlideEdit() {
  const { id } = useParams()
  const { data: slide } = useSlide(+id!)
  const deleteSlide = useDeleteSlide()
  const updateSlide = useUpdateSlide()
  const [modalRm, modalRmActions] = useModalTrigger<Slide>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/slides-home">Slides Home</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {slide!.title.it}
            </li>
          </ol>
        </nav>
        <button
          className="btn  btn-danger"
          onClick={() => modalRmActions.open(slide)}
        >
          <i className="bi bi-trash3-fill"></i> Elimina
        </button>
      </Header>

      <div className="py-3 overflow-y-auto flex-1">
        <SlideForm
          slide={slide}
          save={(formSlide) =>
            updateSlide.mutateAsync(formSlide).then(() =>
              toast.success('Slide salvata con successo!', {
                position: 'bottom-right',
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare la slide {modalRm.value.title.it} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btnoutline-primary"
          >
            Annulla
          </button>
          <button
            className="btn  btn-danger"
            disabled={deleteSlide.isLoading}
            onClick={async () => {
              await deleteSlide.mutateAsync(modalRm.value!.id)
              navigate('/slides-home')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
